import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchEvents } from '../../redux/actions/fetchEvents'
// To set up class names for datepicker components
import 'react-dates/initialize'

import ErrorBoundary from '../../components/elements/ErrorBoundary'
import BrandLoader from '../../components/elements/BrandLoader'
import Views from '../views/Views'
import EventsFiltersBar from '../../components/filters/EventsFiltersBar'

function App() {
  const eventsData = useSelector((state) => state.eventsData)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!eventsData.data && !eventsData.loading && !eventsData.error) {
      dispatch(fetchEvents())
    }
  }, [dispatch, eventsData])

  return (
    <div className="decoupled-events">
      {eventsData.loading ? (
        <BrandLoader />
      ) : eventsData.error ? (
        <ErrorBoundary errorMessage={eventsData.error} />
      ) : (
        <div className="decoupled-events__main u-container">
          <EventsFiltersBar />
          <Views />
        </div>
      )}
    </div>
  )
}

export default App
